__turbopack_context__.v({
  "plcta": "YE7_FG_plcta",
  "plctaGlass": "YE7_FG_plctaGlass",
  "plctaHideOnDesktop": "YE7_FG_plctaHideOnDesktop",
  "plctaPrimary": "YE7_FG_plctaPrimary",
  "plctaWhite": "YE7_FG_plctaWhite",
});
